module.exports = __webpack_public_path__ + "img/ch62.7a775bc6.png";